<h2>{{'packageTable.title' | translate}}</h2>
<qbe-package-table
    class="packoDetails"
    [labelCoverageProvided]="'packageTable.labelCoverageProvided' | translate"
    [labelComfort]="'packageTable.labelComfort' | translate"
    [labelPlus]="'packageTable.labelPlus' | translate"
    [labelExtra]="'packageTable.labelExtra' | translate"
    [labelMax]="'packageTable.labelMax' | translate"
    [labelCoverageDefinitions]="'packageTable.labelCoverageDefinitions' | translate"
    [packageList]="packageList"
    [selectedTab]="selectedTab"
    [variant]="'property'"
    [labelDetails]="labelDetails"
    (detailsClick)="detailsBtnClick()"
></qbe-package-table>
